import {isDesktop} from "../helpers";

export const hidePopupChoosePlace = ($popupInfo,$popupInfoContent) => {
    if (isDesktop()) {
        $popupInfo.removeClass('ticket-system__popup-show ticket-system__popup-show-effect');
        clearPopupChoosePlace($popupInfoContent);

    } else {
        $popupInfo.removeClass('ticket-system__popup-show-effect');
        setTimeout(() => {
            $popupInfo.removeClass('ticket-system__popup-show');
            clearPopupChoosePlace($popupInfoContent);
        }, 100);
    }
}

const clearPopupChoosePlace = ($popupInfoContent) => {
    $popupInfoContent.html('');
}

export const setPopupPosition = (e,$popupInfo) => {
    const mouseX = e.clientX + document.body.scrollLeft;
    const mouseY = e.clientY + document.body.scrollTop;

    const tooltipHeight = $popupInfo.height() + 30;

    let top = mouseY - tooltipHeight / 2 + 25;
    let left = mouseX + 30;

    const style = {
        left: `${left}px`,
        top: `${top}px`
    };

    $popupInfo.css(style);
}